// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "./default/chunk-article-listed.21503237da6e3092180e.js";
	if (chunkId === 38) return "./default/chunk-subscription.e80f086389cfd9807a61.js";
	if (chunkId === 66) return "./66.6958b480d4024599451b.js";
	if (chunkId === 36) return "./default/chunk-small-gallery.05a381eed75a3f55dadf.js";
	if (chunkId === 32) return "./default/chunk-photo-credit-toogle.1a7e1b1ac49c968c4b9a.js";
	if (chunkId === 37) return "./default/chunk-social-click.07f620264863cbf96b0e.js";
	if (chunkId === 40) return "./default/chunk-table.ec568f33ad2629001678.js";
	if (chunkId === 44) return "./default/gallery-in-art-preserve-scroll.745e21a67930587975b8.js";
	if (chunkId === 67) return "./67.bdceca444c29a67f30aa.js";
	if (chunkId === 31) return "./default/chunk-online-reports.db166ad0dcb6acf01054.js";
	if (chunkId === 6) return "./chunk-league-table.7e65a3624568ec99ecdb.js";
	// return url for filenames based on template
	return undefined;
};